import { General } from "../../../../siteManagement/general.js";
import { SheetEventType } from "../../../../siteManagement/sheet.js";
import { Config } from "../../config/config.js";
import { Helper } from "../../util/helper.js";
import { ComponentType } from "../../util/ingridHelper.js";
import { EditableGridHelper } from "./editableGridHelper.js";
import React from "react";

export default class GridDetails extends React.Component<{
    columns: any;
    dataItem: any;
    id: any;
    visible: boolean;
    editable: boolean;
    isSheet: boolean;
    onTemplateClick: (columnField: string, row: any) => void;
}, {
    }>{
    private gridDetailsRef: any;
    private validator: kendo.ui.Validator;
    private kendoEditable: any;
    private ignoredColumns = [
        "selectable",
        "validatable",
        "mobilecontextmenu",
        "mobiletemplate"
    ]

    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        if (this.props.isSheet)
            this.createKendoEditable();

        this.setState({}, () => {
            this.validator = $(this.gridDetailsRef).kendoValidator().data("kendoValidator");
            this.validate();
        })

        if (this.props.isSheet) {
            let sheet = General.Sheet.Manager.getTopMostSheet();
            sheet.bind(SheetEventType.Custom, (cus) => {
                if (cus.command = "onDataChanged") {
                    this.setState({});
                }
            })
        }
    }

    componentDidUpdate(prevProps) {
        this.validate();

        let idChanged = prevProps.id != this.props.id && this.props.id;
        let dataItemChanged = prevProps.dataItem != this.props.dataItem;
        if (!this.props.isSheet && (idChanged || dataItemChanged)) {
            if (this.kendoEditable) {
                this.kendoEditable.destroy();
                $(".grid-details__editable").empty();
                this.kendoEditable = null;
            }
            this.createKendoEditable();
        }
    }

    componentWillUnmount() {
        if (this.kendoEditable && this.props.isSheet)
            this.kendoEditable.destroy();
    }

    private validate = () => {
        if (this.validator) {
            this.validator.validate();
        }
    }

    private createKendoEditable = () => {
        this.kendoEditable = ($(this.gridDetailsRef) as any)
            .kendoEditable({
                fields: this.getColumns().filter(x => !x.columns),
                model: this.props.dataItem,
                clearContainer: false,
                validateOnBlur: false,
                skipFocus: true,
                change: (e) => {}
            }).data("kendoEditable");
        if (!Helper.useMobileGui() && !Config.settings.isMobileApp) {
            $(this.gridDetailsRef).find(':kendoFocusable').eq(0).trigger('focus');
        } else {
            // Auf Mobile soll die Bildschirmtastatur mit dem Numpad angezeigt werden:
            $(this.gridDetailsRef).find('.k-numerictextbox :input').attr('inputmode', 'decimal');

            // Verhindern, dass die Bildschirmtastatur beim Scroll eingeblendet wird, falls man auf eine numerictextbox klickt:
            $(this.gridDetailsRef).find('.k-numerictextbox .k-input-inner').on('touchstart', event => {
                let touchMoved = false;

                $(event.target).one('touchmove', () => touchMoved = true);
                $(event.target).one('touchend', (e) => {
                    if (touchMoved && document.activeElement instanceof HTMLElement) {
                        // Noch besser wäre es, dem vorherigen aktiven Element wieder den Fokus zu geben. Dafür wäre allerdings die Option prevenScroll nötig.
                        // Das wird aber in Chrome auf Mobile Geräten bisher nicht supported (https://issues.chromium.org/issues/41453122).
                        document.activeElement.blur();
                    }
                    touchMoved = false;
                });
            });
        }
    }

    private isEditable = (column) => {
        if (!this.props.editable)
            return false;

        let dataItem = this.props.dataItem;
        if (Helper.hasValue(column.editable)) {
            if (typeof column.editable == "boolean")
                return column.editable;
            else (typeof column.editable == "function")
            return column.editable(dataItem);
        }
        return true;
    }

    private ignoreColumn = (column: kendo.ui.GridColumn) => {
        let ignoreField = typeof column.field === "string" && this.ignoredColumns.includes(column.field.toLocaleLowerCase());
        let ignoreColumn = this.props.isSheet && column["type"] == ComponentType.Component;
        return ignoreField || ignoreColumn;
    }

    private getColumns = () => {
        return this.getColumnsRecursiv(this.props.columns ?? []);
    }

    private getColumnsRecursiv = (columns: kendo.ui.GridColumn[]) => {
        let allColumns: kendo.ui.GridColumn[] = [];
        for (let column of columns) {
            if (!this.ignoreColumn(column) && !Helper.hasValue(column.command) && !Helper.hasValue(column.columns)) {
                allColumns.push(column);
            } else if (Helper.hasValue(column.columns)) {
                let subColumns = this.getColumnsRecursiv(column.columns);
                allColumns.push(column);
                allColumns.push(...subColumns);
            }
        }

        return allColumns;
    }

    private renderColumns = () => {
        const getMobileDetailItem = (column: kendo.ui.GridColumn) => {    
            let templateValue = EditableGridHelper.helper.getTemplate(column, this.props.dataItem);
            let additionalField = this.props.dataItem[column.field + "_additional_data"];
            if(additionalField && additionalField["__fetchingId"])
                templateValue = "";

            let showIsSearchTemplate = column.template && column["type"] == "issearch";
            if (this.ignoreColumn(column))
                return null;
            return <div className="grid-details__item" key={"gridDetails_" + column.field}>
                    <div className={'grid-details__title'}>{column.title}</div>
                    <div id={column.field} className={"grid-details__editable " + (!this.isEditable(column) ? "is-hidden" : "")} data-container-for={column.field} />
                    <div className={"grid-details__template " + (this.isEditable(column) && !showIsSearchTemplate ? "is-hidden" : "")} dangerouslySetInnerHTML={{ __html: templateValue }} onClick={(e) => {
                        this.props.onTemplateClick(column.field, this.props.dataItem);
                    }} />
                </div>
        }

        const getMultiColumn = (multiColumn: kendo.ui.GridColumn) => {
            let elements: JSX.Element[] = [];
            for (let childColumn of multiColumn.columns) {
                let type = childColumn["type"];
                if (type == ComponentType.MultiColumn)
                    elements.push(getMultiColumn(childColumn));
                else {
                    elements.push(getMobileDetailItem(childColumn));
                }
            }
            return <div className="grid-details__item" key={"gridDetails_" + multiColumn.field}>
                <div className="grid-details__title grid-details__title--multi-column">{multiColumn.title}</div>
                <div className="grid-details__item-container">{elements}</div>
            </div>;
        }

        let elements: JSX.Element[] = [];
        for (let rootColumn of this.props.columns) {
            let type = rootColumn["type"];
            var element = (type == ComponentType.MultiColumn || (rootColumn.columns && rootColumn.columns.length > 0))
                ? getMultiColumn(rootColumn)
                : getMobileDetailItem(rootColumn);
            elements.push(element);
        }
        return elements;
    }

    private renderGridDetails = () => {
        if (!this.props.dataItem || !this.props.id)
            return null;

        return <div className={"grid-details"} ref={(ref) => this.gridDetailsRef = ref}>
            {this.renderColumns()}
        </div>
    }

    render() {
        if (!this.props.visible)
            return null;

        return <div className={`grid-details-container ${this.props.isSheet ? "grid-details-container--sheet" : "grid-details-container--grid"}`}>
                {this.renderGridDetails()}
            </div>;
    }
}